import styled, { css } from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';

type SharedRowProps = {
  noExternalUri?: boolean;
  featured?: boolean;
  showReport?: boolean;
};

export const PriceColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 ${layout.measurements.spacingSmall};

  ${media.smallOnly`
    margin: 0 ${layout.measurements.spacingTiny};
  `};
`;

export const PriceAndStockRow = styled.div<SharedRowProps>(
  props => css`
    display: grid;
    grid-template-columns: repeat(3, auto);
    grid-column-gap: ${layout.measurements.spacingSmall};
    align-items: center;

    ${media.smallOnly`
      grid-template-columns: repeat(2, auto);
    `};

    ${!props.featured &&
      css`
        grid-template-columns: auto;
      `}
  `
);

export const PriceLabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${layout.measurements.spacingSmall};
  align-items: flex-end;
`;

export const BadgeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: ${layout.measurements.spacingSmall};
`;

export const PriceTypeNoticeRow = styled.div`
  align-self: end;
`;
